export default "__VITE_ASSET__c00a2ab9__"